import getApproveRejectStore from ".";

export const hasPendingDescription = ({ index }: { index: number }) => {
  const userApprovalData = getApproveRejectStore().approvalData.get()[index];
  const pendingDescription = userApprovalData.descriptionStatus === "pending";
  return pendingDescription;
};
